export default "Try this demo here by dragging the slider, and seeing how blending an image with more noise gradually destroys it.\n"